import Service, { service } from '@ember/service';
import urlBuilder from 'garaje/utils/url-builder';
import { wrappedFetch } from 'garaje/utils/wrapped-fetch';

export default class ExternalAuthenticationService extends Service {
  @service cookies;

  invalidateEnvoyAuth() {
    const url = urlBuilder.envoyLogoutUrl();
    const csrfToken = this.cookies.read('csrf_token');
    const headers = { 'X-CSRF-Token': csrfToken };
    const options = {
      headers,
      method: 'DELETE',
      credentials: 'include',
    };

    return wrappedFetch(url, options);
  }
}
